module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M19.018.002c-.551-.04-.999.412-.999.965V12.98a1 1 0 0 0 1.001 1.001h12.013c.553 0 1.005-.45.965-1.001C31.509 6.039 25.964.491 19.018.002zm8.011 17.983H15.016a1 1 0 0 1-1.001-1.001V4.971c0-.553-.45-1.005-1.001-.965C5.74 4.519 0 10.581 0 17.985 0 25.725 6.275 32 14.015 32c7.404 0 13.468-5.74 13.979-13.014.04-.551-.412-1.001-.965-1.001z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/pie-graph-1.js
// module id = 1342
// module chunks = 14